// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"5293":"c9d68879","7044":"f1b802e9","7082":"9012e4fb","9086":"963f27a7"}[chunkId] + ".css";
};